import { Observable } from 'rxjs';
import { FaqItem } from '../../model/faq-items.model';

export abstract class FaqItemAdapter {
  abstract getDetails(
    faqItemCode: string,
    isUserLoggedIn: boolean
  ): Observable<FaqItem>;
}
